import { useEffect} from "react";
import { useThree } from "@react-three/fiber";
import { PerspectiveCamera } from "three";

export function ResponsiveCamera({ fov, loaded }: { fov: number; loaded: boolean }) {
  const { camera, gl } = useThree();

  useEffect(() => {
    if ("fov" in camera) {
      const cam = camera as PerspectiveCamera;
      cam.fov = fov;
      cam.aspect = gl.domElement.clientWidth / gl.domElement.clientHeight;
      cam.updateProjectionMatrix();
    }
  }, [fov, gl, camera]);

  // ResizeObserver to fix iframe embed issue
  useEffect(() => {
    if (!loaded || !gl?.domElement) return;

    const resizeCanvas = () => {
      gl.setSize(gl.domElement.clientWidth, gl.domElement.clientHeight);
      if ("aspect" in camera) {
        (camera as PerspectiveCamera).aspect = gl.domElement.clientWidth / gl.domElement.clientHeight;
        camera.updateProjectionMatrix();
      }
    };

    resizeCanvas(); // immediate resize once loaded

    const observer = new ResizeObserver(() => {
      resizeCanvas();
    });

    observer.observe(gl.domElement);

    return () => observer.disconnect();
  }, [loaded, gl, camera]);

  return null;
}
